import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme, type ThemeMode } from "../contexts/ThemeContext";
import { cn } from "../lib/utils";

const OPTIONS: { value: ThemeMode; Icon: typeof Sun; label: string }[] = [
  { value: "light", Icon: Sun, label: "Light" },
  { value: "system", Icon: Monitor, label: "System" },
  { value: "dark", Icon: Moon, label: "Dark" },
];

export function ThemeToggle() {
  const { mode, setMode } = useTheme();
  return (
    <div className="inline-flex items-center gap-0.5 rounded-md border border-border bg-background p-0.5">
      {OPTIONS.map(({ value, Icon, label }) => {
        const active = mode === value;
        return (
          <button
            key={value}
            type="button"
            aria-label={label}
            aria-pressed={active}
            onClick={() => setMode(value)}
            className={cn(
              "inline-flex h-7 w-7 items-center justify-center rounded-[5px] text-muted-foreground transition-all",
              active
                ? "bg-primary-soft text-primary-soft-foreground shadow-[inset_0_0_0_1px_color-mix(in_oklab,var(--color-primary)_15%,transparent)]"
                : "hover:bg-muted hover:text-foreground",
            )}
          >
            <Icon className="h-3.5 w-3.5" strokeWidth={2.25} />
          </button>
        );
      })}
    </div>
  );
}
